import { render, staticRenderFns } from "./GroupsEvents.vue?vue&type=template&id=4c2a6c00&scoped=true&"
import script from "./GroupsEvents.vue?vue&type=script&lang=js&"
export * from "./GroupsEvents.vue?vue&type=script&lang=js&"
import style0 from "./GroupsEvents.vue?vue&type=style&index=0&id=4c2a6c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2a6c00",
  null
  
)

export default component.exports